import * as z from "zod";

export const carrierRatePipelineSchema = z.object({
  carrier: z.string(),
  fileRoles: z.array(z.string()),
});

export type CarrierRatePipeline = z.infer<typeof carrierRatePipelineSchema>;

export const listCarrierRatePipelines = {
  name: "listCarrierRatePipelines" as const,
  input: z.object({}),
  output: z.object({ pipelines: z.array(carrierRatePipelineSchema) }),
};
